export default {
    SET_EDIT_MODAL_DATA (state, data) {
        let keys = Object.keys(data);
        for (let i = 0; i < keys.length; i++) {
            state.requestDurationEditModal.data[keys[i]] = data[keys[i]];
        }
    },
    TOGGLE_LIST_REFRESH (state, data) {
        state.requestDurationEditModal.requestDurationList.refreshList = data;
    },
    SET_EDIT_MODAL_ERRORS (state, data) {
        state.requestDurationEditModal.errors = data;
    },
    TOGGLE_EDIT_MODAL (state, data) {
        state.requestDurationEditModal.isOpen = data.open;
        if (data.open === true) {
            return;
        }

        state.requestDurationEditModal.errors = {};

        let keys = Object.keys(state.requestDurationEditModal.data);

        for (let i = 0; i < keys.length; i++) {
            if (Array.isArray(state.requestDurationEditModal.data[keys[i]])) {
                state.requestDurationEditModal.data[keys[i]] = [];
            } else {
                state.requestDurationEditModal.data[keys[i]] = '';
            }
        }
    },
};
